import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './global.css';
import './configs/font';
import './configs/axios';
import { getGAUserId } from './analytics';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

getGAUserId();

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
